import React, { useState } from 'react'
import { Table, TableBody, TableContainer } from '@mui/material'
import { OrderType, TableHeadCellPropsType, PaginationResponse } from '@/state'

import { TableHeadGenericComponent } from './header.component'
import SkeletonLoader from '../skeleton'
import NoContentAvailable from '../no-content-available/index.component'

import PaginationTable from '../pagination-table/index.component'

type TableGenericComponentProps<T> = {
  headCells: TableHeadCellPropsType<T>[]
  isLoading: boolean
  body: React.ReactNode
  rowLength: number
  pagination?: PaginationResponse
  hasAction?: boolean
  leftContent?: React.ReactNode
  noContentElement?: React.ReactNode
  smallPagination?: boolean
  order?: OrderType
  orderBy?: keyof T
  createSortHandler?: (
    property: keyof T,
  ) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  handleChangePage?: (newPage: number) => void
  handleChangeLimit?: (numRows: number) => void
}

export const TableGenericComponent = <T extends { [key: string]: any }>({
  order,
  orderBy,
  headCells,
  isLoading,
  body,
  rowLength,
  pagination,
  hasAction,
  leftContent,
  noContentElement,
  smallPagination,
  createSortHandler,
  handleChangePage,
  handleChangeLimit,
}: TableGenericComponentProps<T>) => {
  const showPagination =
    rowLength !== 0 || (rowLength === 0 && pagination?.page > 1)

  const [tableDense, setTableDense] = useState(false)

  const handleSetTableDense = () => {
    setTableDense(!tableDense)
  }

  return (
    <>
      {!isLoading && rowLength > 0 && (
        <TableContainer>
          <Table size={tableDense ? 'small' : 'medium'}>
            <TableHeadGenericComponent<T>
              order={order}
              orderBy={orderBy}
              createSortHandler={createSortHandler}
              headCells={headCells}
              hasAction={hasAction}
            />
            <TableBody>{body}</TableBody>
          </Table>
        </TableContainer>
      )}
      {isLoading ? (
        <SkeletonLoader element="table" />
      ) : (
        <>
          {rowLength === 0 && (noContentElement || <NoContentAvailable />)}
          {showPagination && (
            <>
              {pagination && handleChangePage && (
                <PaginationTable
                  pagination={pagination}
                  handleChangePage={handleChangePage}
                  handleChangeLimit={handleChangeLimit}
                  leftContent={leftContent}
                  handleSetTableDense={handleSetTableDense}
                  tableDense={tableDense}
                  small={smallPagination}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
